import GeoJSONReader from 'jsts/org/locationtech/jts/io/GeoJSONReader';
import GeoJSONWriter from 'jsts/org/locationtech/jts/io/GeoJSONWriter';

/**
 * A GeoJSONReader instance for reading GeoJSON data into JSTS geometries.
 * @type {GeoJSONReader}
 */
export const reader = new GeoJSONReader();

/**
 * A GeoJSONWriter instance for writing JSTS geometries into GeoJSON data.
 * @type {GeoJSONWriter}
 */
export const writer = new GeoJSONWriter();
